var map = {
  "./da.json": [
    "18771",
    [
      38064
    ]
  ],
  "./fi.json": [
    "78713",
    [
      96066
    ]
  ],
  "./sv.json": [
    "96669",
    [
      65870
    ]
  ],
  "./ja.json": [
    "47565",
    [
      74654
    ]
  ],
  "./lt.json": [
    "92980",
    [
      30645
    ]
  ],
  "./sl.json": [
    "8875",
    [
      86488
    ]
  ],
  "./fr.json": [
    "59380",
    [
      27253
    ]
  ],
  "./es.json": [
    "96912",
    [
      57129
    ]
  ],
  "./no.json": [
    "91739",
    [
      46504
    ]
  ],
  "./cs.json": [
    "12062",
    [
      52307
    ]
  ],
  "./en.json": [
    "49127",
    [
      99628
    ]
  ],
  "./description/en.json": [
    "68340",
    [
      32917
    ]
  ],
  "./pl.json": [
    "4643",
    [
      91497
    ]
  ],
  "./hu.json": [
    "39459",
    [
      76640
    ]
  ],
  "./nl.json": [
    "54026",
    [
      17207
    ]
  ],
  "./de.json": [
    "26847",
    [
      65396
    ]
  ],
  "./pt.json": [
    "50968",
    [
      97793
    ]
  ],
  "./it.json": [
    "5037",
    [
      85406
    ]
  ],
  "./et.json": [
    "39206",
    [
      54370
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 96166;
module.exports = __rspack_async_context;
